import { Suspense, useState } from "react";
import Button from "../../components/Button/Button";
import { BootstrapModal } from "../../components/BootstrapModal/Modal";
import InputField from "../../components/InputField/InputField";
import { Form, Formik } from "formik";
import {
  useAddCustomer,
  useGetAreas,
  useGetBrands,
  useGetCategory,
  useGetCities,
  useGetCustomer,
  useGetCustomerData,
  useGetGroupingData,
  useGetMarketer,
  useSearchNumbers,
} from "../../hooks/useCrm";
import { SimpleSelect1 } from "../../components/SimpleSelect/SimpleSelect1";
import { InputField1 } from "../../components/InputField1/InputField1";
import { SelectMulti } from "../../components/MultiSelect/MultiSelect";
import {
  CustomerRanking,
  CustomerType,
  MethodOfIntroduction,
  MethodOfSell,
} from "../../data/crmGeneralData";
import { CgClose } from "react-icons/cg";
import Loading from "../../components/Loadings/LoadingTable";
import { CrmLayout } from "../../layout/CrmLayout";
import { Link, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import Typography from "../../components/Typography/Typography";
import ProtectedRoute from "../../layout/ProtectedLayout/ProtectedRoute";
import { RouteMode } from "../../constant/enum/RouteAccessLevel";
import { CrmRoute } from "../../routers/CrmRoute";
import { useRecoilState } from "recoil";
import { crmshowAtom } from "../../shared/crm-show";
const initvalue = {
  FirstName: "",
  LastName: "",
  Phone: "",
  PhoneTwo: "",
  methodOfIntroduction: "",
  IdIdCities: "",
  KindSeller: "",
  IdMarketer: "",
  Area: "",
  RankingCustomer: "",
  OldPrice: "",
  KindCustomer: "",
  meIdUserSabtActivityCrm: "",
  ProbabilityOfPurchase: "0",
  NameCategory: "",
  NameCompany: "",
  BrandCategory5: "",
  Description: "",
};
const initialValues = {
  Phone: "",
};
export const Crm = () => {
  const [recoilShow, setRecoilShow] = useRecoilState(crmshowAtom);
  const [showCrmButton, setShowCrmButton] = useState(true);

  const handleClose = () => setRecoilShow(false);
  const handleShow = () => setRecoilShow(true);
  const [numbertype, setNumberType] = useState({});
  const [form, setForm] = useState(initvalue);
  const [userinfo, setUserInfo] = useState();
  const [newuserid, setNewUserId] = useState();
  const { data: areas } = useGetAreas();
  const { data: cities } = useGetCities();
  const { data: brands } = useGetBrands();
  const { data: cat } = useGetCategory();
  const { data: marketer } = useGetMarketer();
  const { data: customerresponsible } = useGetCustomer();

  const { mutateAsync: Searchnumbers, isLoading: SearchnumbersLoading } =
    useSearchNumbers();
  const { mutateAsync: AddCustomer, isLoading: AddCustomerLoading } =
    useAddCustomer();
  const {
    mutateAsync: CustomerData,
    isLoading: CustomerDataLoading,
    data: customerdata,
  } = useGetCustomerData();

  const { data: grouping } = useGetGroupingData();
  const methodOfIntroduction =
    grouping?.data?.groping_new_user_crms[0]?.methodOfIntroduction?.map(
      (item) => {
        return {
          value: item.ContentGroping,
          label: item.ContentGroping,
        };
      }
    );
  const rankingCustomer =
    grouping?.data?.groping_new_user_crms[0]?.RankingCustomer?.map((item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    });
  const kindSeller = grouping?.data?.groping_new_user_crms[0]?.KindSeller?.map(
    (item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    }
  );
  const kindCustomer =
    grouping?.data?.groping_new_user_crms[0]?.KindCustomer?.map((item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    });
  const Areas = areas?.data?.areas;
  const areasOptions = Areas?.map((area) => {
    return {
      value: area.IdAreas,
      label: area.NameAreas,
    };
  });
  const Brands = brands?.data?.brands;
  const brandsOption = Brands?.map((brand) => {
    return {
      value: brand.IdBrands,
      label: brand.NameBrands,
    };
  });
  const Cities = cities?.data?.ProvincesAndCities;
  const CitiesOptions = Cities?.map((city) => {
    return {
      value: city.IdCities,
      label: city.NameProvinces + "-" + city.NameCities,
    };
  });
  const methodsOfIntroduction = MethodOfIntroduction.map((method) => {
    return {
      value: method.value,
      label: method.label,
    };
  });
  const categories = cat?.data?.categories;
  const categoriesOptions = categories?.map((cat) => {
    return {
      value: cat.NameCategories,
      label: cat.NameCategories,
    };
  });
  const methodsOfSell = MethodOfSell.map((sell) => {
    return {
      value: sell.value,
      label: sell.label,
    };
  });
  const Marketers = marketer?.data?.Marketer;
  const MarketersOptions = Marketers?.map((mark) => {
    return {
      value: mark.IdUser,
      label: mark.FirstName + " " + mark.LastName,
    };
  });
  const customerRanking = CustomerRanking.map((rank) => {
    return {
      value: rank.value,
      label: rank.label,
    };
  });
  const customerType = CustomerType.map((type) => {
    return {
      value: type.value,
      label: type.label,
    };
  });
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const OnSubmit = async (valuesSearch) => {
    await Searchnumbers(valuesSearch).then(
      (response) =>
        setNumberType({ status: response.data, phone: valuesSearch }),
      setForm({ ...form, Phone: valuesSearch.Phone })
    );
  };

  const handleGetInUserFile = async (id) => {
    await CustomerData(id).then((response) => setUserInfo(response.data));
  };

  const handleAddCustomer = async (CustomerDetail) => {
    await AddCustomer(CustomerDetail).then((response) => {
      setNewUserId(response?.data?.IdS0alesOpportunities);
      setForm(initvalue);
    });
  };
  const renderRoute = () => {
    return CrmRoute.map((route, index) => (
      <Route key={route.path} path={route.path} element={route.component} />
    ));
  };

  return (
    <ProtectedRoute layoutMode={RouteMode.CRM_ROUTE}>
      <CrmLayout handleShow={handleShow} showCrmButton={showCrmButton}>
        <BootstrapModal
          handleClose={handleClose}
          show={recoilShow}
          moreButton={!showCrmButton}
          size={"lg"}
          closebutton={
            <Button
              style={{ width: "40px", border: "none" }}
              onclick={() => {
                setNumberType({});
                setRecoilShow(false);
              }}
            >
              <CgClose />
            </Button>
          }
        >
          {SearchnumbersLoading ? (
            <Loading />
          ) : (
            <>
              {!newuserid ? (
                <>
                  {!numbertype.status ? (
                    <>
                      <Formik initialValues={initialValues} onSubmit={OnSubmit}>
                        <Form>
                          <InputField
                            name={"Phone"}
                            label={"افزودن شماره"}
                            type={"number"}
                            placeholder={"جستجو در شماره ها"}
                            id={"NumberSearchCrm"}
                          ></InputField>
                          <Button type="submit" bgColor="#0d6efd" color="#fff">
                            افزودن شماره
                          </Button>
                        </Form>
                      </Formik>
                    </>
                  ) : numbertype.status.StatusFile === "Ok" ? (
                    <>
                      <div className="w-100 mb-4 mt-2">
                        <Typography size={"16px"}>مشخصات مشتری</Typography>
                      </div>
                      <div className="d-flex flex-wrap">
                        <div className="w-50">
                          <Typography
                            space={"10px 0px"}
                            htmlFor=""
                            className="d-block mb-2 text-muted"
                            size={"14px"}
                          >
                            نام و نام خانوادگی
                          </Typography>
                          <Typography space={"10px 0px"} size={"17px"}>
                            {numbertype.status.Users[0].FirstName}{" "}
                            {numbertype.status.Users[0].LastName}
                          </Typography>
                        </div>
                        <div className="w-50">
                          <Typography
                            space={"10px 0px"}
                            htmlFor=""
                            className="d-block mb-2 text-muted"
                            size={"15px"}
                          >
                            شماره تماس
                          </Typography>
                          <Typography space={"10px 0px"} size={"17px"}>
                            {numbertype.status.Users[0].Phone}
                          </Typography>
                        </div>
                        <div className="w-50">
                          <Typography
                            space={"10px 0px"}
                            size={"14px"}
                            htmlFor=""
                            className="d-block mb-2 text-muted"
                          >
                            نوع
                          </Typography>
                          <Typography space={"10px 0px"} size={"17px"}>
                            {
                              numbertype.status.sales_opportunities[0]
                                .KindCustomer
                            }
                          </Typography>
                        </div>
                        <div className="w-50">
                          <Typography
                            space={"10px 0px"}
                            size={"14px"}
                            htmlFor=""
                            className="d-block mb-2 text-muted"
                          >
                            نوع فروش
                          </Typography>
                          <Typography space={"10px 0px"} size={"17px"}>
                            {
                              numbertype.status.sales_opportunities[0]
                                .KindSeller
                            }
                          </Typography>
                        </div>
                        <div className="w-50">
                          <Typography
                            space={"10px 0px"}
                            size={"14px"}
                            htmlFor=""
                            className="d-block mb-2 text-muted"
                          >
                            نوع آشنایی
                          </Typography>
                          <Typography space={"10px 0px"} size={"17px"}>
                            {
                              numbertype.status.sales_opportunities[0]
                                .methodOfIntroduction
                            }
                          </Typography>
                        </div>
                        <div className="w-50">
                          <Typography
                            space={"10px 0px"}
                            size={"14px"}
                            htmlFor=""
                            className="d-block mb-2 text-muted"
                          >
                            رتبه مشتری
                          </Typography>
                          <Typography space={"10px 0px"} size={"17px"}>
                            {
                              numbertype.status.sales_opportunities[0]
                                .RankingCustomer
                            }
                          </Typography>
                        </div>
                      </div>
                      <div className="w-100 d-flex">
                        <Button
                          bgColor="#0d6efd"
                          color="#fff"
                          className="d-inline-block "
                          style={{ margin: "0px 5px" }}
                        >
                          <LinkStyled>
                            <Link
                              to={`/dashboard/crm/customer-file/${numbertype.status.sales_opportunities[0].IdS0alesOpportunities}`}
                              onClick={() =>
                                handleGetInUserFile(
                                  {
                                    IdS0alesOpportunities:
                                      numbertype.status.sales_opportunities[0]
                                        .IdS0alesOpportunities,
                                  },
                                  setRecoilShow(false),
                                  setNumberType({})
                                )
                              }
                            >
                              رفتن به پرونده مشتری
                            </Link>
                          </LinkStyled>
                        </Button>
                        <Button
                          bgColor="#f1416c"
                          color="#fff"
                          className="d-inline-block "
                          onclick={() => setNumberType({})}
                          style={{ margin: "0px 5px" }}
                        >
                          افزودن شماره دیگر
                        </Button>
                      </div>
                    </>
                  ) : numbertype.status.StatusFile === "NotUSer" ? (
                    <>
                      {AddCustomerLoading ? (
                        <Loading />
                      ) : (
                        <>
                          <div className="d-flex flex-wrap">
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  important={true}
                                  onChange={handleChange}
                                  className={"form-control"}
                                  name={"FirstName"}
                                  label={"نام"}
                                  type={"text"}
                                  placeholder={"نام"}
                                  id={"NameCustomer"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  important={true}
                                  onChange={handleChange}
                                  className={"form-control"}
                                  name={"LastName"}
                                  label={"نام خانوادگی"}
                                  type={"text"}
                                  placeholder={"نام خانوادگی"}
                                  id={"FamilyNameCustomer"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  important={true}
                                  onChange={handleChange}
                                  name={"Phone"}
                                  label={"شماره تماس"}
                                  type={"text"}
                                  placeholder={"شماره تماس"}
                                  id={"NumberCustomer"}
                                  className={"form-control"}
                                  value={numbertype.phone.Phone}
                                  readonly={true}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"PhoneTwo"}
                                  label={"شماره های بیشتر"}
                                  type={"text"}
                                  placeholder={"09351234567-09351234567"}
                                  id={"PhoneTwoCustomer"}
                                  className={"form-control"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SelectMulti
                                  label={"دسته بندی"}
                                  res={categoriesOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      NameCategory: Array.isArray(e)
                                        ? e.map((x) => x.value).join(",")
                                        : [],
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SelectMulti
                                  label={"برند"}
                                  res={brandsOption}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      BrandCategory5: Array.isArray(e)
                                        ? e.map((x) => x.label).join(",")
                                        : [],
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  important={true}
                                  label={"نحوه آشنایی"}
                                  res={methodOfIntroduction}
                                  width="100%"
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      methodOfIntroduction: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  important={true}
                                  label={"استان شهر"}
                                  res={CitiesOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      IdIdCities: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  important={true}
                                  label={"نوع فروش"}
                                  res={kindSeller}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      KindSeller: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"لیست بازاریابان"}
                                  res={MarketersOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      IdMarketer: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"منطقه"}
                                  res={areasOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      Area: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"رتبه بندی مشتری"}
                                  res={rankingCustomer}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      RankingCustomer: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"OldPrice"}
                                  label={"مبلغ دوره قبلی"}
                                  type={"text"}
                                  placeholder={"مبلغ دوره قبلی"}
                                  id={"NumberCustomer"}
                                  className={"form-control"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  important={true}
                                  label={"نوع مشتری"}
                                  res={kindCustomer}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      KindCustomer: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  important={true}
                                  label={"مسئول پرونده"}
                                  res={customerResponsibleOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      meIdUserSabtActivityCrm: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-100 p-1">
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"Description"}
                                  label={"توضیحات بیشتر"}
                                  type={"text"}
                                  placeholder={"توضیحات"}
                                  id={"Description"}
                                  className={"form-control"}
                                ></InputField1>
                              </div>
                            </div>
                          </div>
                          <div className="w-100">
                            <Button
                              bgColor="#0d6efd"
                              color="#fff"
                              onclick={() => handleAddCustomer(form)}
                            >
                              ذخیره
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  ) : numbertype.status.StatusFile === "NotAccount" ? (
                    <>
                      {AddCustomerLoading ? (
                        <Loading />
                      ) : (
                        <>
                          <div className="d-flex flex-wrap">
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  className={"form-control"}
                                  name={"FirstName"}
                                  label={"نام"}
                                  type={"text"}
                                  placeholder={"نام"}
                                  id={"NameCustomer"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  className={"form-control"}
                                  name={"LastName"}
                                  label={"نام خانوادگی"}
                                  type={"text"}
                                  placeholder={"نام خانوادگی"}
                                  id={"FamilyNameCustomer"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"Phone"}
                                  label={"شماره تماس"}
                                  type={"text"}
                                  placeholder={"شماره تماس"}
                                  id={"NumberCustomer"}
                                  className={"form-control"}
                                  value={numbertype.phone.Phone}
                                  readonly={true}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"PhoneTwo"}
                                  label={"شماره های بیشتر"}
                                  type={"text"}
                                  placeholder={"09351234567-09351234567"}
                                  id={"PhoneTwoCustomer"}
                                  className={"form-control"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SelectMulti
                                  label={"دسته بندی"}
                                  res={categoriesOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      NameCategory: Array.isArray(e)
                                        ? e.map((x) => x.value).join(",")
                                        : [],
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"نحوه آشنایی"}
                                  res={methodsOfIntroduction}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      methodOfIntroduction: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"استان شهر"}
                                  res={CitiesOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      IdIdCities: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"نوع فروش"}
                                  res={methodsOfSell}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      KindSeller: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"لیست بازاریابان"}
                                  res={MarketersOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      IdMarketer: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"منطقه"}
                                  res={areasOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      Area: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"رتبه بندی مشتری"}
                                  res={customerRanking}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      RankingCustomer: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"OldPrice"}
                                  label={"مبلغ دوره قبلی"}
                                  type={"text"}
                                  placeholder={"مبلغ دوره قبلی"}
                                  id={"NumberCustomer"}
                                  className={"form-control"}
                                ></InputField1>
                              </div>
                            </div>
                            <div className=" p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"نوع مشتری"}
                                  res={customerType}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      KindCustomer: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="p-1" style={{ width: "33.3%" }}>
                              <div className="form-group">
                                <SimpleSelect1
                                  label={"مسئول پرونده"}
                                  res={customerResponsibleOptions}
                                  onChange={(e) =>
                                    setForm({
                                      ...form,
                                      meIdUserSabtActivityCrm: e.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-100 p-1">
                              <div className="form-group">
                                <InputField1
                                  onChange={handleChange}
                                  name={"Description"}
                                  label={"توضیحات بیشتر"}
                                  type={"text"}
                                  placeholder={"توضیحات"}
                                  id={"Description"}
                                  className={"form-control"}
                                ></InputField1>
                              </div>
                            </div>
                          </div>
                          <div className="w-100">
                            <Button
                              bgColor="#0d6efd"
                              color="#fff"
                              onclick={() => handleAddCustomer(form)}
                            >
                              ذخیره و رفتن به پرونده مشتری
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  <div className="w-100">
                    <Typography className="h5  pt-3 pb-3 pl-3">
                      پرونده مشتری با موفقیت ایجاد شد.
                    </Typography>
                  </div>
                  <div className="w-100">
                    <Button
                      className="w-50"
                      bgColor="#009ef7"
                      color="#fff"
                      onclick={() => {
                        setRecoilShow(false);
                        setNewUserId();
                        setNumberType({});
                      }}
                    >
                      <Link
                        to={`/dashboard/crm/customer-file/${newuserid}`}
                        style={{ color: "#fff" }}
                      >
                        مشاهده پرونده مشتری
                      </Link>
                    </Button>
                    <Button
                      className="w-50"
                      bgColor="#f1416c"
                      color="#fff"
                      onclick={() => {
                        setNewUserId();
                        setNumberType({});
                      }}
                    >
                      پرونده جدید
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
        </BootstrapModal>
        <Suspense fallback={<Loading />}>
          <Routes>{renderRoute()}</Routes>
        </Suspense>
      </CrmLayout>
    </ProtectedRoute>
  );
};
const LinkStyled = styled.div`
  a {
    color: #fff;
  }
`;
